import React, { useState } from 'react';
import { Chord } from 'tonal';
import { getGroupedScaleChords } from '../utils/chordsHelpers';
import ChordAutocomplete from './ChordAutocomplete';

interface ChordSelectorProps {
  selectedKey: string;
  scale: string;
  selectedChord: string;
  setSelectedChord: (chord: string) => void;
  compact?: boolean;
  closeModal?: () => void;
}

const ChordSelector: React.FC<ChordSelectorProps> = ({ selectedKey, scale, selectedChord, setSelectedChord, compact, closeModal }) => {
  const groupedScaleChords = getGroupedScaleChords(`${selectedKey} ${scale}`);

  const handleChordToggle = (chord: string) => {
    if (selectedChord === chord) {
      setSelectedChord('');
    } else {
      setSelectedChord(chord);
    }
  };

  const selectedChordNotes = selectedChord ? Chord.get(selectedChord).notes : [];

  return (
    <div className="form-control">
      {!compact && <div className="mb-4">
      <label className="label">
        <span className="label-text">Selected Chord:</span>
      </label>
      
        {selectedChord ? (
          <div className="btn btn-accent">{`${selectedChord} (${selectedChordNotes.join(', ')})`}</div>
        ) : (
          <div className="btn">None</div>
        )}
      </div>
      }

      <label className="label">
        <span className="label-text">Chord Search:</span>
      </label>
      <ChordAutocomplete setSelectedChord={setSelectedChord} />

      {scale.toLowerCase() !== 'chromatic' && (
        <>
          <label className="label mt-4">
            <span className="label-text">Chord by Scale Degree:</span>
          </label>
          <div className="overflow-x-auto">
            <table className="table table-sm table-pin-rows table-pin-cols">
              {/* <thead>
                <tr>
                  <th>Degree</th>
                  <th>Chord Variations</th>
                </tr>
              </thead> */}
              <tbody>
                {groupedScaleChords.map((chordGroup, groupIndex) => (
                  <tr key={groupIndex}>
                    <td className="font-bold">
                      {chordGroup[0].numeral}
                    </td>
                    <td>
                      <div className="flex flex-wrap gap-2">
                        {chordGroup.map((chord, chordIndex) => (
                          <button
                            key={chordIndex}
                            onClick={() => { handleChordToggle(chord.name); compact && closeModal();}}
                            className={`btn ${selectedChord === chord.name ? 'btn-accent' : ''} ${compact ? " btn-sm" : ""}`}
                          >
                            {chord.name}
                          </button>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ChordSelector;